import axios from 'axios';
import { PLANT_ITEM_NEW_API_BASE_URL } from 'plantItemNew/constants/plantItemConstants';
import { clearForm } from './formSlice';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
  pdfData: null,
  pdfFailed: false,
  pdfLoading: false,
  pdfSucceeded: false,
};

const pdfLinkSlice = createSlice({
  name: 'pdfLink',
  initialState,
  reducers: {
    cleanPdf() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearForm, () => {
        return initialState;
      })
      .addCase(downloadSummaryPDF.pending, (state) => {
        state.pdfData = null;
        state.pdfLoading = true;
        state.pdfFailed = false;
        state.pdfSucceeded = false;
      })
      .addCase(downloadSummaryPDF.rejected, (state) => {
        state.pdfData = null;
        state.pdfLoading = false;
        state.pdfFailed = true;
        state.pdfSucceeded = false;
      })
      .addCase(downloadSummaryPDF.fulfilled, (state, action) => {
        state.pdfData = action.payload ?? null;
        state.pdfLoading = false;
        state.pdfFailed = false;
        state.pdfSucceeded = true;
      });
  },
});

export const downloadSummaryPDF = createAsyncThunk(
  'pdfLink/downloadPdf',
  async (applicationId) => {
    const resp = await axios.post(
      `${PLANT_ITEM_NEW_API_BASE_URL}/generatepdf/${applicationId}`,
      {},
      {
        responseType: 'blob',
      },
    );

    return resp.data;
  },
  {
    condition: (_, { getState, extra }) => {
      const pdfLink = getState().pdfLink;
      return !pdfLink.pdfLoading;
    },
  },
);

export const { cleanPdf } = pdfLinkSlice.actions;
export const pdfLinkReducer = pdfLinkSlice.reducer;
